import React from 'react';
import Modal from '../../../Modal';
import { Login } from '../../../Authorization';
import { bodyScrollFix } from '../../../../utils';

export default ({ onOk, visible, isLoading, onRestore, ...rest }) => {
  return (
    <Modal
      title={null}
      open={visible}
      footer={null}
      width={'auto'}
      {...rest}
      wrapClassName="auth"
      afterClose={bodyScrollFix}
    >
      <Login onLogin={onOk} onSignup={() => {}} onRestore={onRestore} />
    </Modal>
  );
};
